import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m14.502.14-14 8.062c-.364.208-.53.52-.5.937.032.417.24.703.626.86l4.375 1.812V15c0 .468.22.78.664.937.442.156.81.057 1.101-.297l1.906-2.312 3.954 1.625c.291.125.58.11.867-.047a.91.91 0 0 0 .492-.719l2-13.031c.062-.417-.08-.742-.43-.977-.349-.234-.7-.247-1.055-.039Zm-8.5 14.859v-2.782l1.704.703L6.003 15Zm7-.97-6.437-2.655 6.234-7.375c.073-.084.068-.167-.015-.25-.084-.084-.167-.089-.25-.016l-7.985 6.812-3.546-1.468 14-8.078-2 13.03Z"
    }, null, -1)
  ])))
}
export default { render: render }